import { css } from '@emotion/react';
import { DesignToken, ShadowToken, SpacingToken } from '@livechat/design-system-react-components';

export const cardLinkStyles = css`
  text-decoration: none;
  height: 64px;
  min-width: 240px;
  max-width: 280px;
  color: inherit;
`;

export const cardContainerStyles = css`
  display: flex;
  width: 100%;
  height: 100%;
  color: var(${DesignToken.ContentBasicPrimary});

  &:hover div:first-of-type {
    background-color: var(${DesignToken.SurfacePrimaryHover});
  }
`;

export const cardImageContainerStyles = css`
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: var(${ShadowToken.Float});
  background-color: var(${DesignToken.SurfacePrimaryDefault});
  border-radius: 8px;
`;

export const cardImageStyles = (product: string) => css`
  min-height: 32px;
  min-width: 32px;

  ${(product === 'KnowledgeBase' || product === 'HelpDesk') &&
  `
    min-height: 28px;
  `};

  ${product === 'OpenWidget' &&
  `
    height: 32px;
    min-height: 28px;
`};

  ${product === 'Text Accounts' &&
  `
    min-width: 20px;
`};
`;

export const cardProductNameStyles = css`
  color: var(${DesignToken.ContentBasicPrimary});
  text-align: left;
  margin: 0 0 0 var(${SpacingToken.Spacing4});
`;

export const cardDescriptionStyles = css`
  margin: 0 0 0 var(${SpacingToken.Spacing4});
  color: var(${DesignToken.ContentBasicPrimary});
  text-align: left;
  width: 160px;
  overflow-wrap: normal;
`;
